import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Trigger a browser download of a server-generated CSV.
 * Uses fetch with Authorization header (browser <a download> can't send headers).
 */
export async function downloadCsv(resource) {
  try {
    const res = await api.get(`/export/${resource}.csv`, { responseType: "blob" });
    const cd = res.headers?.["content-disposition"] || "";
    const match = /filename="([^"]+)"/.exec(cd);
    const filename = match ? match[1] : `${resource}.csv`;
    const blob = new Blob([res.data], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success(`Exported ${filename}`);
  } catch (e) {
    toast.error(e.response?.status === 403 ? "You don't have permission to export this" : "Export failed");
  }
}
